/*
 * First query for my profile archived Tickets/Vouchers data
 */
export default {
    showArchived: true,
    page: 1,
}